import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, "Share Feedback", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "We're always trying our best to improve StageHub, and your feedback can help us do that.", -1)
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "nav nav-pills nav-pills-custom justify-content-center" }
const _hoisted_6 = { class: "nav-item mb-3 me-3 me-lg-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "nav-icon mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-lightbulb fs-1 p-0" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "nav-text text-gray-800 fw-bolder fs-6 lh-1" }, "Idea", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary" }, null, -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "nav-item mb-3 me-3 me-lg-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "nav-icon mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bug fs-1 p-0" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "nav-text text-gray-800 fw-bolder fs-6 lh-1" }, "Problem", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute bottom-0 w-100 h-4px bg-danger" }, null, -1)
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "nav-item mb-3 me-3 me-lg-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "nav-icon mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-question fs-1 p-0" })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "nav-text text-gray-800 fw-bolder fs-6 lh-1" }, "Question", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute bottom-0 w-100 h-4px bg-info" }, null, -1)
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "nav-item mb-3 me-3 me-lg-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "nav-icon mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-heart fs-1 p-0" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "nav-text text-gray-800 fw-bolder fs-6 lh-1" }, "Praise", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute bottom-0 w-100 h-4px bg-success" }, null, -1)
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "form-check form-switch form-check-custom form-check-solid m-auto mt-4 mt-md-0 mb-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isFlexibleSwitch"
}, " Yes, you may contact me to follow-up. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBase = _resolveComponent("ModalBase")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "Share Feedback",
    size: "modal-fullscreen-sm-down modal-md",
    ref: "modal",
    "has-footer": false,
    "has-toolbar": true
  }, {
    body: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.feedback.category = 'Idea')),
                class: _normalizeClass([{'active': _ctx.feedback.category === 'Idea'}, "nav-link btn btn-outline btn-flex btn-active-color-primary flex-column overflow-hidden w-75px h-85px pt-5 pb-2"])
              }, _hoisted_10, 2)
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.feedback.category = 'Problem')),
                class: _normalizeClass([{'active': _ctx.feedback.category === 'Problem'}, "nav-link btn btn-outline btn-flex btn-active-color-danger flex-column overflow-hidden w-75px h-85px pt-5 pb-2"])
              }, _hoisted_15, 2)
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.feedback.category = 'Question')),
                class: _normalizeClass([{'active': _ctx.feedback.category === 'Question'}, "nav-link btn btn-outline btn-flex btn-active-color-info flex-column overflow-hidden w-75px h-85px pt-5 pb-2"])
              }, _hoisted_20, 2)
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.feedback.category = 'Praise')),
                class: _normalizeClass([{'active': _ctx.feedback.category === 'Praise'}, "nav-link btn btn-outline btn-flex btn-active-color-success flex-column overflow-hidden w-75px h-85px pt-5 pb-2"])
              }, _hoisted_25, 2)
            ])
          ])
        ]),
        _createVNode(_component_InputGroup, { label: "Feedback" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              rows: "4",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.feedback.content) = $event))
            }, null, 512), [
              [_vModelText, _ctx.feedback.content]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.feedback.contactMe) = $event)),
            id: "isFlexibleSwitch"
          }, null, 512), [
            [_vModelCheckbox, _ctx.feedback.contactMe]
          ]),
          _hoisted_27
        ]),
        _createVNode(_component_Button, {
          onClick: _ctx.sendFeedback,
          type: "primary",
          "is-loading": _ctx.isLoading,
          "is-disabled": _ctx.v$.$invalid
        }, {
          default: _withCtx(() => [
            _createTextVNode("Submit Feedback ")
          ]),
          _: 1
        }, 8, ["onClick", "is-loading", "is-disabled"]),
        _createVNode(_component_Button, {
          onClick: _ctx.toggleClosed,
          type: "secondary",
          class: "mt-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])), [
        [_directive_loading, _ctx.isLoading]
      ])
    ]),
    _: 1
  }, 512))
}